<template>
  <el-dialog class="modal-95-70-60" title="Счетчики сообщений по шаблону"
             v-model="countersModalVisible">
    <el-table :data="currentCounters" style="width: 100%">
      <el-table-column label="Месяц" :formatter="r => bMonth(r.month)"/>
      <el-table-column label="Счетчик" prop="counter"/>
    </el-table>
  </el-dialog>

  <SimpleTechnoTable
      :loading="loading"
      :records="filteredTemplates"
      ref="mTable"
  >
    <template #default>
      <el-form label-position="top" :model="filter" style="width: 100%" :size="small ? 'small': 'default'">
        <el-row :gutter="20">
          <el-col :xs="24" :md="6">

            <el-form-item label="Статус">
              <el-select v-model="filter.status" class="full-width">
                <el-option value="" label="Все"/>
                <el-option value="active" label="Активен"/>
                <el-option value="awaiting" label="На рассмотрении"/>
                <!--                <el-option value="awaiting_activation" label="Ожидает активации"/>-->
                <!--                <el-option value="awaiting_deactivation" label="Ожидает деактивации"/>-->
                <el-option value="rejected" label="Отклонён"/>
              </el-select>
            </el-form-item>

            <el-form-item label="Группа операторов">
              <el-select v-model="filter.operator" class="full-width">
                <el-option value="" label="Все"/>
                <el-option v-for="o in operatorsOptions" :value="o.id" :label="o.name"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :md="6">
            <el-form-item label="Тип трафика">
              <el-select v-model="filter.type" class="full-width">
                <el-option value="" label="Все"/>
                <el-option v-for="o in trafficTypeOptions" :value="o.value" :label="o.name"/>

              </el-select>
            </el-form-item>
            <slot name="admin-client-filter"/>
          </el-col>
          <el-col :xs="24" :md="6">
            <el-form-item label="Подпись">
              <el-select v-model="filter.sender" class="full-width" filterable>
                <el-option value="" label="Все"/>
                <el-option v-for="s in filterSenderOptions" :value="s" :label="s"/>
              </el-select>

            </el-form-item>
          </el-col>
          <el-col :xs="24" :md="6">
            <el-form-item label="Шаблон">
              <el-input v-model="filter.text"/>
            </el-form-item>
            <slot name="admin-paid-filter"></slot>

          </el-col>
        </el-row>
      </el-form>
<!--      <p class="text-red"><u>Использование шаблонов по оператору МегаФон возможно только в пакетной тарификации</u></p>-->
    </template>
    <template #table="tScope">
      <el-table :data="tScope.records" style="width: 100%">
        <el-table-column label="" width="30" v-if="showSelection">
          <template #header>
            <input type="checkbox" v-model="selectAll" :value="true"/>
          </template>
          <template #default="scope">
            <input type="checkbox" v-model="selection" :value="scope.row.id"/>
          </template>
        </el-table-column>
        <slot name="admin-user-id-col"></slot>
        <el-table-column :formatter="addEditDate" label="Дата добавления" width="120"/>
        <el-table-column label="Статус" width="150">
          <template #default="scope">
            <span v-html="statusVerbose(scope.row.status)"></span>

            <el-tag size="sm" :type="scope.row.delayedStatusAction === 'activate' ? 'success' : 'danger'"
                    v-if="scope.row.delayedStatusAction && (showActivationDate || scope.row.delayedStatusAction !== 'activate')">
              {{ scope.row.delayedStatusAction === 'activate' ? 'Вкл.' : 'Отозван' }} с
              {{ formatDate(scope.row.delayedStatusActionDate) }}
            </el-tag>
            <el-tag size="sm" type="danger"
                    v-if="scope.row.revokeRequested">
              Запрошен отзыв
            </el-tag>
            <el-tag size="sm" type="warning"
                    v-if="scope.row.status === 'awaiting' && (isMts(scope.row) || isT2(scope.row))">
              {{scope.row.activationDateRequested === 'now' ? 'Как можно скорее' : 'Со след. месяца'}}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="Группа операторов" width="150">
          <template #default="scope">
            <span>{{ scope.row.oper_group }}</span><br/>
            <span class="text-red" v-if="scope.row.isPayable">Платный</span>
          </template>
        </el-table-column>
        <el-table-column :formatter="trafficType" label="Тип трафика" width="150"/>
        <el-table-column prop="sender_name" label="Подпись" width="150"/>
        <el-table-column label="Шаблон" min-width="300">
          <template #default="scope">
            <pre class="text-pre">{{ scope.row.template }}</pre>
            <pre class="text-pre" v-if="scope.row.sampleMessage" style="color: var(--el-text-color-disabled); display: block; margin-top: 4px;">{{ scope.row.sampleMessage }}</pre>
          </template>
        </el-table-column>
        <el-table-column min-width="140" label="Счетчик">
          <template #header>
            <el-button type="success" size="small" @click="showAllCountersCumsum()">
              Счётчик: {{ allCountersCumsum }}
            </el-button>
          </template>
          <template #default="scope">
            <el-button type="success" size="small" @click="showAllCounters(scope.row)"
                       :disabled="!scope.row.counters.length">
              {{ lastMonthCounter(scope.row) }}
            </el-button>
          </template>
        </el-table-column>
        <slot name="admin-actions"></slot>

      </el-table>
    </template>
    <template #before-pagination>
      <el-button type="success" @click="$emit('onAdd')">Добавить шаблоны</el-button>
      <slot name="client-extension"></slot>
      <el-dropdown>
        <el-button type="primary" style="margin-left: 10px">Скачать&nbsp;&nbsp;<font-awesome-icon icon="chevron-down"/>
        </el-button>
        <template #dropdown>
          <el-dropdown-menu style="width: 200px">
            <el-dropdown-item
                v-for="month in static.months"
                @click="exportTable(month.value)"
            >{{ month.label }}
            </el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </template>
    <template #after-pagination>
      <p style="margin-left: 20px">({{ filteredTemplates.length }} шабл.)</p>
    </template>
  </SimpleTechnoTable>


</template>

<script>

import moment from "moment"
import iconv from "iconv-lite";
import SimpleTechnoTable from "@shared/components/layout/simple-techno-table.component.vue";
import templateTrafTypeFormatter from "@shared/mixins/templateTrafficTypeFormatter";

export default {
  name: "ServiceTemplatesTable",
  props: ["templates", "loading", "small", "filterInjection", "showActivationDate", "showSelection"],
  components: {SimpleTechnoTable},
  mixins: [templateTrafTypeFormatter],
  watch: {
    "filteredTemplates": function (newV) {
      this.recalculateCumsum()
      this.$emit("filtered", newV || [])
    },
    selectAll(v) {
      if (v && v.length) {
        this.selection = this.getVisibleIds()
      } else {
        this.selection = []
      }

    },
    selection(v) {
      this.$emit("onSelection", v)
    }
  },
  mounted() {
    let now = moment()
    let months = []
    for (let i = 1; i <= 2; i++) {
      months.push({label: now.locale("ru").format("YYYY MMMM"), value: now.startOf("month").format("MM.YYYY")})
      now = moment().subtract(i, "months")
    }
    this.static.months = months

  },
  methods: {
    getFilteredTemplates() {
      return this.filteredTemplates
    },
    getVisibleIds() {
      return this.$refs.mTable.getVisibleRows().map(r => r.id)
    },
    resetSelection() {
      this.selection = []
      this.selectAll = []
    },
    addEditDate(t) {
      if (!t.addEditDate) return ""
      return moment(t.addEditDate).format("DD.MM.YYYY HH:mm")
    },
    statusVerbose(status, plainString = false) {
      if (status === "awaiting") return plainString ? 'На рассмотрении' : "<span class='text-yellow'>На рассмотрении</span>"
      if (status === "active") return plainString ? 'Активен' : "<span class='text-green'>Активен</span>"
      if (status === "rejected") return plainString ? 'Отклонён' : "<span class='text-red'>Отклонён</span>"
      if (status === "awaiting_activation") return plainString ? 'Ожидает активации' : "<span class='text-yellow'>Ожидает активации</span>"
      if (status === "awaiting_deactivation") return plainString ? 'Ожидает деактивации' : "<span class='text-yellow'>Ожидает деактивации</span>"
      return ""
    },


    specificMonthCounter(row, month) {
      let lastCounter = row.counters.find((c1) => c1.month === month)
      return lastCounter ? String(lastCounter.counter) : "0"

    },
    showAllCounters(row) {
      this.currentCounters = row.counters.sort((c1, c2) => moment(c2.month, "MM.YYYY").valueOf() - moment(c1.month, "MM.YYYY").valueOf())
      this.countersModalVisible = true
    },
    showAllCountersCumsum() {
      let allVisibleTemplates = this.getFilteredTemplates()
      this.currentCounters = Object.values(allVisibleTemplates.reduce((acc, t) => {
        for (let counter of (t.counters || [])) {
          if (!acc[counter.month]) acc[counter.month] = {month: counter.month, counter: 0}
          acc[counter.month].counter += Number(counter.counter) || 0
        }
        return acc
      }, {})).sort((c1, c2) => moment(c2.month, "MM.YYYY").valueOf() - moment(c1.month, "MM.YYYY").valueOf())
      this.countersModalVisible = true
    },
    bMonth(v) {
      return moment(v, "MM.YYYY").format("MMMM YYYY")
    },
    recalculateCumsum() {
      this.allCountersCumsum = (this.filteredTemplates || []).reduce((acc, t) => {
        return acc + (Number(this.lastMonthCounter(t)) || 0)
      }, 0)
    },
    exportTable(month) {
      const serviceTemplatesTrafficTypes = {
        "service": "Сервисный",
        "authorisation": "Авторизационный",
        "informational": "Информационный",
        "transactional": "Транзакционный",
        "templated_add": "Рекламный с шаблоном",
      }
      let csvContent = [
        iconv.encode(`Дата добавления;Статус;Оператор;Имя;Тип шаблона;Текст;Количество сообщений\n`, 'win1251'),
        ...this.filteredTemplates.map(a => {
          return iconv.encode([
            this.addEditDate(a),
            this.statusVerbose(a.status, true),
            a.oper_group,
            a.sender_name,
            serviceTemplatesTrafficTypes[a.traffic_type],
            '"' + a.template.replace(/"/g, '""') + '"',
            this.specificMonthCounter(a, month)
          ].join(";") + "\n", 'win1251')
        })
      ]
      let blob = new Blob(csvContent, {type: 'text/csv'});

      let a = document.createElement('a');
      a.download = `Сервисные шаблоны ${this.bMonth(month)}.csv`;
      a.href = URL.createObjectURL(blob);
      a.click();
    },
    isMts(t) {
      return t.operatorGroup === '570e2c11b52438c11a38f99c'
    },
    isT2(t) {
      return t.operatorGroup === '570e2cb6b52438c11a38f99e'
    }
  },
  computed: {
    filteredTemplates() {
      let senderRegex = this.filter.sender ? new RegExp(this.filter.sender, "gi") : null
      let textRegex = this.filter.text ? new RegExp(escapeRegExp(this.filter.text), "gi") : null

      return this.templates.filter(t => {

        if (this.filter.operator && t.opg_id !== this.filter.operator) return false
        if (typeof this.filterInjection === 'function' && this.filterInjection(t)) return false

        if (this.filter.type && this.filter.type !== t.traffic_type) return false
        if (this.filter.status && this.filter.status !== t.status) return false

        if (senderRegex) {
          senderRegex.lastIndex = -1
          if (!senderRegex.test(t.sender_name)) return false
        }
        if (textRegex) {
          textRegex.lastIndex = -1
          if (!textRegex.test(t.template)) return false
        }
        return true
      })
    },
    filterSenderOptions() {
      return Array.from(new Set(this.templates.map(t => t.sender_name || ""))).filter(v => v.trim()).sort((t1, t2) => t1.localeCompare(t2))
    },

  },
  data() {
    return {
      filter: {
        operator: "",
        type: "",
        sender: "",
        text: "",
        status: "",
        delayedAction: ""
      },
      countersModalVisible: false,
      currentCounters: [],
      allCountersCumsum: 0,
      operatorsOptions: [
        {id: "570e2be8b52438c11a38f99b", name: "РФ_МегаФон"},
        {id: "570e2c11b52438c11a38f99c", name: "РФ_МТС"},
        {id: "570e2c6cb52438c11a38f99d", name: "РФ_Билайн"},
        {id: "570e2cb6b52438c11a38f99e", name: "РФ_Теле2"},
        {id: "570e2f37b52438c11a38f9a0", name: "РФ_МОТИВ"}
      ],
      trafficTypeOptions: [
        {
          value: "service",
          name: "Сервисный",
          availableOperators: ['570e2c11b52438c11a38f99c', '570e2c6cb52438c11a38f99d', '570e2cb6b52438c11a38f99e', '570e2f37b52438c11a38f9a0']
        },
        {
          value: "authorisation",
          name: "Авторизационный",
          availableOperators: ['570e2be8b52438c11a38f99b', '570e2c11b52438c11a38f99c']
        },
        {value: "informational", name: "Информационный", availableOperators: ['570e2be8b52438c11a38f99b']},
        {value: "transactional", name: "Транзакционный", availableOperators: ['']},
        {value: "templated_add", name: "Рекламный с шаблоном", availableOperators: ['570e2be8b52438c11a38f99b']}
      ],
      static: {
        months: []
      },
      rulesListVisible: false,
      selectAll: [],
      selection: [],
    }
  }
}

</script>
